var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user--settings_svg__clip0_61530_7486)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.5V6h-1.576a3.725 3.725 0 00-.549-1.315l1.118-1.117-1.06-1.06-1.118 1.117A3.726 3.726 0 0018 3.075V1.5h-1.5v1.576c-.47.097-.916.283-1.315.549l-1.117-1.118-1.06 1.06 1.117 1.118A3.727 3.727 0 0013.575 6H12v1.5h1.576c.096.47.283.916.549 1.315l-1.118 1.117 1.06 1.06 1.118-1.117c.4.266.845.453 1.315.55V12H18v-1.576c.47-.096.916-.283 1.315-.549l1.117 1.118 1.06-1.06-1.117-1.118c.266-.4.453-.846.55-1.315H22.5zM17.25 9a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5zM12 22.5h-1.5v-3.75a2.253 2.253 0 00-2.25-2.25h-3A2.253 2.253 0 003 18.75v3.75H1.5v-3.75A3.755 3.755 0 015.25 15h3A3.755 3.755 0 0112 18.75v3.75zM6.75 7.5a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm0-1.5a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user--settings_svg__clip0_61530_7486"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgUserSettings;